(function ($) {
  $('body').each(function () {
    function animateFrom(elem, direction) {
      direction = direction | 1;

      var x = 0,
        y = direction * 100;
      if (elem.classList.contains("gs_reveal_fromLeft")) {
        x = -100;
        y = 0;
      } else if (elem.classList.contains("gs_reveal_fromRight")) {
        x = 100;
        y = 0;
      }
      gsap.fromTo(elem, { x: x, y: y, autoAlpha: 0 }, {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto"
      });
    }

    window.addEventListener("DOMContentLoaded", function () {
      gsap.registerPlugin(ScrollTrigger);

      gsap.utils.toArray(".gs_reveal").forEach(function (elem) {
        ScrollTrigger.create({
          trigger: elem,
          once: true,
          onEnter: function () { animateFrom(elem) },
        });
      });
    });
  });
})(jQuery);
